import Vue from 'vue'
import VueMatomo from 'vue-matomo'
import VueRouter from 'vue-router'
import Layout from './components/shared/layout'
import axios from 'axios'

window.$ = window.jQuery = require('jquery')

const routes = [
    {
        path: '/:token',
        name: 'booking',
        component: require('./components/shared/booking-clinic').default,
        meta: { pageTitle: 'Boka behandling - Hälsoresurs' },
        children: [
            {
                path: 'clinics/:clinic',
                name: 'modal-clinic',
                component: require('./components/shared/modal-clinic').default,
                meta: { closeTo: 'booking', pageTitle: 'Massör - Hälsoresurs' }
            },
            {
                path: 'addresses/:address',
                name: 'modal-address',
                component: require('./components/shared/modal-address').default,
                meta: { closeTo: 'booking', pageTitle: 'Adress - Hälsoresurs' }
            }
        ]
    },
    { path: '/:token/cards', name: 'cards', component: require('./components/customer/cards').default, meta: { pageTitle: 'Klippkort - Hälsoresurs' } },
    {
        path: '/:token/cards/:card',
        name: 'card',
        component: require('./components/customer/card').default,
        meta: { pageTitle: 'Klippkort - Hälsoresurs' },
        children: [
            {
                path: 'clinics/:clinic',
                name: 'card-clinic',
                component: require('./components/shared/modal-clinic').default,
                meta: { closeTo: 'card', pageTitle: 'Massör - Hälsoresurs' }
            }
        ]
    },
    { path: '/:token/shop', name: 'shop', component: require('./components/customer/shop').default, meta: { pageTitle: 'Köp - Hälsoresurs' } },
    { path: '/:token/faq', name: 'faq', component: require('./components/shared/faq').default, meta: { pageTitle: 'FAQ - Hälsoresurs' } },
    { path: '/:token/tipsa', name: 'tipsa', component: require('./components/customer/referral').default, meta: { pageTitle: 'Värva en vän - Hälsoresurs' } }
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

router.afterEach((to, from) => {
    const pathParts = window.location.pathname.split('/')
    pathParts.splice(1, 1)

    console.log('afterEach to ' + to.name)
    if (to.name === 'card') {
        pathParts.splice(2, 1)
        pathParts.push('card')
    }

    let modifiedUrl = pathParts.join('/') + window.location.search
    if (!modifiedUrl) {
        modifiedUrl = '/'
    }

    console.log('modifiedUrl')
    console.log(modifiedUrl)

    window._paq.push(['setCustomUrl', modifiedUrl])
    window._paq.push(['setDocumentTitle', to.meta.pageTitle])
    window._paq.push(['trackPageView'])
})

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.pageTitle

    if (from.name == 'modal-clinic' || from.name == 'modal-address' || from.name == 'card-clinic') {
        jQuery('html').removeClass('modal-open')
    }

    if (to.name == 'modal-clinic' || to.name == 'modal-address' || to.name == 'card-clinic') {
        jQuery('html').addClass('modal-open')
    }

    next()
})

Vue.use(VueRouter)
Vue.use(VueMatomo, {
    host: 'https://halsoresurs.matomo.cloud/',
    siteId: 1,
    disableCookies: true
})

Vue.mixin({
    data () {
        return {
            app_version: window.app_version,
            auth: window.auth
        }
    },
    methods: {
        linkTo (path) {
            return '/' + this.$route.params.token + path
        },
        matomoTrackEvent (action, name, value) {
            window._paq.push(['trackEvent', action, name, value])
        },
        productAreaName (product_area_id) {
            return product_area_id === 2 ? 'Personlig träning' : 'Massage'
        }
    }
})

const app = new Vue({
    router,
    components: {
        Layout
    },
    created () {
        axios.defaults.baseURL = '/data/' + this.$route.params.token
    }
}).$mount('#app')

// Browser
if (!window.matchMedia('(display-mode: standalone)').matches && (!('standalone' in window.navigator) || (('standalone' in window.navigator) && !window.navigator.standalone))) {
    var element = document.getElementById('body')
    element.classList.add('browser')
}

// Standalone PWA
if (window.matchMedia('(display-mode: standalone)').matches || (('standalone' in window.navigator) && window.navigator.standalone)) {
    var element = document.getElementById('body')
    element.classList.add('standalone')
}
